import { UPDATE_PATH } from '../actions/actionTypes';

// will need to be fixed as this is not available via nucleus
const urlInitial = ''; // document.querySelector('link[rel=canonical]')?.getAttribute('href');

export default (state = { url: urlInitial }, action) => {
  switch (action.type) {
    case UPDATE_PATH: {
      const { url } = action;
      return {
        ...state,
        url,
      };
    }
    default:
      return state;
  }
};
